export const SET_CALENDAR_SHEET = 'SET_CALENDAR_SHEET';
export const SET_WORKERS = 'SET_WORKERS';
export const SET_CALENDAR_DATA = 'SET_CALENDAR_DATA';
export const SET_VIEW = 'SET_VIEW';
export const SET_TASKS_MODAL_VISIBLE = 'SET_TASKS_MODAL_VISIBLE';
export const SET_TASKS_MODAL_DATA = 'SET_TASKS_MODAL_DATA';
export const SET_MODE = 'SET_MODE';
export const SET_STATE = 'SET_STATE';
export const SET_LOCAL_TASK = 'SET_LOCAL_TASK';
export const SET_INFO_MODAL_VISIBLE = 'SET_INFO_MODAL_VISIBLE';
export const SET_CHANGEABLE_TASK_STATUS = 'SET_CHANGEABLE_TASK_STATUS';
export const SET_INNER_ACTIVATION_OF_CHANGE = 'SET_INNER_ACTIVATION_OF_CHANGE';
export const TOGGLE_OWNER = 'TOGGLE_OWNER';
